import { FormGroup } from '@angular/forms';
import {
  getTrackBy,
  updateHeaderStyle
} from '@com-delta-idp/mnx-skymiles-shared';
import { Option } from '@com-delta-omnichannel/aura';
import {
  ConversionData,
  EnrollDetail,
  EnrollType,
  ExtensionData,
  FormData,
  FormValue,
  Options
} from './models/options.interfaces';

export class OptionsExtendedComponent {
  displayTooltip = false;

  getSelectedValue(form: FormValue): EnrollDetail[] {
    return Object.keys(form).map((selectedType) => ({
      type: selectedType as EnrollType,
      code:
        selectedType === 'conversion'
          ? form['conversion'].code
          : form['extension'].value
    }));
  }

  updateSelections(content: Options) {
    if (content.form.controls['extension']) {
      content.review.selections[0].subtitle =
        content.form.value.extension.label;
      content.review.selections[1].subtitle =
        content.form.value.conversion.title;
    } else {
      content.review.selections[0].subtitle =
        content.form.value.conversion.title;
    }
    return content;
  }

  scrollToError(form: FormGroup, selectId: string): void {
    const element = <HTMLElement>(
      document.querySelector(this.getErrorControlElement(form, selectId))
    );
    if (element) {
      element.scrollIntoView({
        behavior: 'auto',
        block: 'center'
      });
    }
  }

  getErrorControlElement(form: FormGroup, selectId: string): string {
    let className = '';
    if (form.controls['extension'] && form.controls['extension'].invalid) {
      const selectElement = document.getElementById(selectId);
      selectElement && selectElement.focus();
      className = '.rollover-options__extension';
    } else {
      className = '.rollover-options__conversion';
    }
    return className;
  }

  getPlaceholderText(steps: FormData<Option | null>[]): string {
    if (steps.length === 2) {
      return (steps[0].content.feature as ExtensionData).title;
    }
    return '';
  }

  getDropDownItems(steps: FormData<Option | null>[]): Option[] {
    if (steps.length === 2) {
      return (steps[0].content.feature as ExtensionData).options;
    }
    return [];
  }

  updateTooltip(active: boolean, invalidForm: boolean) {
    this.displayTooltip = active && invalidForm ? true : false;
  }

  active(value: boolean, invalidForm: boolean) {
    updateHeaderStyle(value);
    this.updateTooltip(value, invalidForm);
  }

  getTrackByIndex(index: number): number {
    return getTrackBy(index);
  }

  getRadioGroup(data: ExtensionData | ConversionData[]): ConversionData[] {
    return data as ConversionData[];
  }
}
